import { v4 as uuidv4 } from 'uuid';

export const generateCanonicalName = (name: string): string => {
  return name.toLowerCase().replace(/[^a-z0-9]/g, '_');
};

export const generateIdentifier = (canonicalName: string): string => {
  return `${canonicalName}_${uuidv4().split('-')[0]}`;
}; 